/**
 * Un SIRET, une seule entreprise (db/037). Ces fonctions servent à repérer
 * les fiches saisies deux fois, avant le blocage ou malgré lui.
 */

/** Les chiffres seuls : « 418 693 669 00032 » et « 41869366900032 » sont le même SIRET. */
export function cleSiret(siret: string): string {
  return siret.replace(/\D/g, '');
}

/** Pour chaque fiche dont le SIRET est partagé, les autres fiches qui le portent. */
export function doublonsSiret<T extends { id: string; siret: string }>(
  fiches: readonly T[]
): Map<string, T[]> {
  const parCle = new Map<string, T[]>();
  for (const f of fiches) {
    const cle = cleSiret(f.siret);
    if (cle === '') continue;
    parCle.set(cle, [...(parCle.get(cle) ?? []), f]);
  }
  const doublons = new Map<string, T[]>();
  for (const groupe of parCle.values()) {
    if (groupe.length < 2) continue;
    for (const f of groupe)
      doublons.set(
        f.id,
        groupe.filter((g) => g.id !== f.id)
      );
  }
  return doublons;
}

/** Le refus, mot pour mot celui de la base. */
export function messageSiretPris(raisonSociale: string): string {
  return `Ce SIRET est déjà celui de « ${raisonSociale} ». Ouvrez sa fiche plutôt que d’en créer une seconde.`;
}
